export enum CastReportType {
  emergency = "至急きてください",
  contact = "連絡ください",
  exit = "退出します",
}
